import useModal from '@/composables/useModal'
import { reactive } from 'vue'
import i18n from '@/i18n/i18n'

export default async function () {
  const dialogProps = reactive({
    title: i18n.global.t('confirmation'),
    label: i18n.global.t('confirmationMsgFoVisaServiceDetailsMSG1')
  })

  const { confirm } = useModal(dialogProps)
  try {
    await confirm()
    return true
  } catch (error) {
    return false
  }
}
